import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';

export default function PerfVsIndexCapsuleChartHelp() {
    return (
        <IconTooltip>
            <div>
                Performance Vs Index Chart
                <br /> <br />
                The Performance Vs Index Capsule compares the price movement of
                the symbol versus that of an index. The price movement for both
                the symbol and index is calculated as the % change from previous
                close.
                <br /> <br />
                This comparison helps to identify if price changes are
                attributed to a general market trend or symbol-specific
                movements.
                <br /> <br />
                The Index can be changed in the chart configuration
                <br /> <br />
                You can also view precise values at a specific time by
                “flipping” the Capsule (click on a the chart).
            </div>
        </IconTooltip>
    );
}
